import 'bootstrap-sass';
import 'bootstrap-slider';
import _slider from './_slider';
import {isNumeric, isTouchDevice} from '../common/_globals';

class LikertSlider {

    protected _lastShowTooltipTime: Date;

    protected initialized: boolean = false;

    public initOnce(): void {

        if (this.initialized) {
            return;
        }
        this.initialized = true;
        _slider.initOnce();

        const _this = this;
        $(function () {

            /**
             * The time when a slider option was changed latest.
             */
            _this._lastShowTooltipTime = new Date();

            // Init sliders
            $('.sl-js-likert-slider .sl-js-bootstrap-slider').each(function () {
                const values = $(this).data("slider-values");
                const itemElementID = $(this).data("item-element-id");
                const min = $(this).data("slider-min");
                const max = $(this).data("slider-max");
                const step = $(this).data("slider-step");
                const missingOptions = $(this).data("missing-options");
                const ticks = [];
                // noinspection JSMismatchedCollectionQueryUpdate
                const tickLabels = [];
                const $containerElement = $(this).closest('.sl-js-slider');
                for (let tick = min; tick <= max; tick += step) {
                    ticks.push(tick);
                    tickLabels.push(_this.getOptionLabel($containerElement, tick));
                }
                const slider: JQuery = _slider.bootstrapSlider($(this), [{
                    // Don't use the slider's default tooltip but the custom one specified below
                    tooltip: 'hide',
                    ticks: ticks
                }]);
                const sliderElement = _slider.bootstrapSlider(slider, ['getElement']);

                // Set current value
                const $inputElement = $('#' + itemElementID, $(this).closest('.sl-slider-column'));
                const hasValue = isNumeric($inputElement.val());
                if (hasValue) {
                    // Apply value that is already set
                    const valueIndex = _this.getValueIndex(values, <number>$inputElement.val());
                    _slider.bootstrapSlider(slider, ['setValue', valueIndex]);
                } else {
                    _slider.hideHandle(slider);
                    _slider.bootstrapSlider(slider, ['setValue', min]);
                }

                // Missing values
                $.each(missingOptions, function (key, missingOption: number) {
                    const $missingOptionTick = $('.slider-tick', sliderElement).eq(missingOption);
                    $missingOptionTick.addClass('sl-option-tick-missing-value');
                });

                // Use custom bootstrap tooltip instead of the default tooltip of the slider,
                // because the slider's default tooltip doesn't support the required features (i.e. html).
                const $sliderHandle = $('.min-slider-handle', sliderElement);
                // Tooltip for slider handle
                $sliderHandle.tooltip({
                    container: '#' + sliderElement.id + ' .min-slider-handle',
                    placement: 'top',
                    trigger: 'manual',
                    html: true
                });
                // Make sure to show the handle's tooltip if it's in use
                let isHandleTooltipShown = false;
                $sliderHandle.on('hide.bs.tooltip', function () {
                    isHandleTooltipShown = false;
                });
                $sliderHandle.on('show.bs.tooltip', function () {
                    isHandleTooltipShown = true;
                });
                // Reload handle tooltip for the first time in order to initialize
                _this.reloadHandleTooltip(slider);
                _this.hideHandleTooltip(slider);

                const $sliderRow = $(sliderElement).closest('.sl-js-item-row');
                if (isTouchDevice()) {
                    $(document).on('verticalScrolling', function () {
                        if (!_slider.isSliderSliding()) {
                            // When swiping make sure to hide all tooltips
                            $(this).find('.sl-js-likert-horizontal-slider-element .min-slider-handle').each(function () {
                                $(this).tooltip('hide');
                            });
                        }
                    }).on('touchend', function (e: JQuery.TouchEndEvent) {
                        if (_slider.hasSliderFocus()) {
                            _this.resetMarkingOfSliders(e.target);
                        }
                    });
                } else {
                    // Tooltips for slider ticks
                    let tickIndex = 0;
                    $('.slider-tick', sliderElement).each(function () {
                        if (_this.hasOptionLabel($containerElement, tickIndex)) {
                            $(this).tooltip('destroy'); // Destroy previous tooltip
                            const sliderTickId = 'slider-tick-' + sliderElement.id + '-' + tickIndex;
                            $(this).attr('id', sliderTickId);
                            $(this).tooltip({
                                container: '#' + sliderTickId,
                                placement: 'top',
                                trigger: 'hover',
                                html: true,
                                title: _this.getOptionLabel($containerElement, tickIndex)
                            });
                            $(this).on('show.bs.tooltip', function () {
                                // Hide the tooltip of the handle if a tooltip of a tick is shown
                                _this.hideHandleTooltip(slider);
                            });
                            const $tickElement = $(this);
                            $tickElement.on('mouseenter mouseleave', function () {
                                $('.tooltip', $tickElement).on('mouseenter mouseleave', function () {
                                    $tickElement.tooltip('hide');
                                });
                            });
                        }
                        tickIndex++;
                    });

                    // Show tooltip on 'mouseenter' and hide on 'mouseleave'
                    $sliderRow.on('mouseenter', function () {
                        if (!_slider.isHandleHidden(slider)) {
                            _this.showHandleTooltip(slider);
                        }
                    }).on('mouseleave focusout', function () {
                        _this.hideHandleTooltip(slider);
                    });
                    $sliderHandle.on('mouseenter', function () {
                        // Make sure the handle's tooltip is shown
                        if (!isHandleTooltipShown) {
                            _this.showHandleTooltip(slider);
                        }
                    });
                }

                slider.on('slideStart', function (event: JQuery.Event) {
                    if (isTouchDevice() && _slider.hasSliderFocus()) {
                        _this.resetMarkingOfSliders(sliderElement);
                    }
                    $sliderHandle.trigger('focus');
                    if (_slider.isHandleHidden(slider)) {
                        // Show the handle and trigger change event
                        _this.showHandle(slider);
                        if (min === (<any>event).value) {
                            slider.trigger('change');
                        }
                    }
                    if (isTouchDevice()) {
                        // Only mark active rows on touch devices.
                        // On desktops this works already fine per default.
                        _slider.markActiveSliderRow($sliderRow);
                    }
                    // Make sure the handle's tooltip is shown
                    if (!isHandleTooltipShown) {
                        _this._lastShowTooltipTime = new Date();
                        _this.showHandleTooltip(slider);
                    }
                    _slider.sliderHasFocus(true);
                    _slider.sliderIsSliding(true);
                }).on('change', function () {
                    // The slider changed
                    if (_this.hasOptionLabel($containerElement, _slider.bootstrapSlider(slider, ['getValue']))) {
                        _this.reloadHandleTooltip(slider);
                        _this.showHandleTooltip(slider);
                    } else {
                        _this.hideHandleTooltip(slider);
                    }
                    const val = _this.getValue(slider);
                    _slider.setValue(slider, val);
                    _this._lastShowTooltipTime = new Date();
                    _this.setHandleTooltipTimeout(slider);
                }).on('slideStop', function () {
                    _slider.sliderIsSliding(false);
                });
            });
        });
    }

    protected showHandle(slider: JQuery): void {
        this._lastShowTooltipTime = new Date();
        const $sliderHandle = $('.min-slider-handle', _slider.bootstrapSlider(slider, ['getElement']));
        $sliderHandle.css('background-color', '');
    }

    protected showHandleTooltip(slider: JQuery): void {
        const $containerElement = slider.closest('.sl-js-slider');
        if (this.hasOptionLabel($containerElement, _slider.bootstrapSlider(slider, ['getValue']))) {
            const $sliderHandle = $('.min-slider-handle', _slider.bootstrapSlider(slider, ['getElement']));
            $sliderHandle.tooltip('show');
            // Hide tooltip on mouse hover
            if (!isTouchDevice()) {
                const _this = this;
                $('.tooltip', $sliderHandle).on('mouseenter mouseleave', function () {
                    _this.hideHandleTooltip(slider);
                });
            }
            this.setHandleTooltipTimeout(slider);
        }
    }

    protected hideHandleTooltip(slider: JQuery): void {
        const $sliderHandle = $('.min-slider-handle', _slider.bootstrapSlider(slider, ['getElement']));
        $sliderHandle.tooltip('hide');
    }

    /**
     * Hides tooltip automatically after timeout
     */
    protected setHandleTooltipTimeout(slider: JQuery): void {
        const tooltipTimeout = 2000;
        const _this = this;
        setTimeout(function () {
            const now: Date = new Date();
            if (<number><any>now - <number><any>_this._lastShowTooltipTime >= tooltipTimeout) {
                _this.hideHandleTooltip(slider);
            }
        }, tooltipTimeout);
    }

    protected reloadHandleTooltip(slider: JQuery): void {
        const $sliderHandle = $('.min-slider-handle', _slider.bootstrapSlider(slider, ['getElement']));
        const $containerElement = slider.closest('.sl-js-slider');
        const index = _slider.bootstrapSlider(slider, ['getValue']);
        const optionLabel = this.getOptionLabel($containerElement, index);
        $sliderHandle.attr('data-original-title', optionLabel).tooltip('show');
    }

    protected getValue(slider: JQuery): number {
        const $sliderElement = slider.closest('.sl-js-bootstrap-slider');
        const values = $sliderElement.data("slider-values");
        const index = _slider.bootstrapSlider(slider, ['getValue']);
        return parseInt(values[index]);
    }

    protected hasOptionLabel($containerElement: JQuery, index: number): boolean {
        const optionLabelHtml = $('#sl-js-hidden-option-label-' + index + ' span', $containerElement).html();
        return optionLabelHtml.length > 0;
    }

    protected getOptionLabel($containerElement: JQuery, index: number): string {
        const $optionLabel = $('#sl-js-hidden-option-label-' + index, $containerElement);
        return $optionLabel.html();
    }

    protected getValueIndex(values: number[], value: number): number {
        for (let index = 0; index < values.length; index++) {
            if (values[index] === value) {
                return index;
            }
        }
        return -1;
    }

    /**
     * Mark given slider as active. Mark other sliders as inactive and hide their tooltips.
     *
     */
    protected resetMarkingOfSliders(activeElement: Element): void {
        let hasActiveSliderRow = false;
        const _this = this;
        $('.sl-js-slider .sl-js-item-row.sl-row-hover').each(function () {
            if ($.contains(this, activeElement)) {
                _slider.markActiveSliderRow($(this));
                hasActiveSliderRow = true;
            } else {
                _this.hideHandleTooltip(_slider.bootstrapSlider($('.sl-js-bootstrap-slider', this), []));
                _slider.unmarkInactiveSliderRow($(this));
            }
        });
        _slider.sliderHasFocus(hasActiveSliderRow);
    }
}

export default new LikertSlider();